export const BREAKPOINT_MD = 1024;
export const BREAKPOINT_SM = 840;
export const BREAKPOINT_XS = 380;
